/**
 * `styleConfig.creatorDisplay` — дефолтный режим отображения мест секции креатора
 * (`spot` / `image` / `event` / `link` / `label`). Ключ нужен не только креатору: правило
 * владельца подписи (`utils/layerLabelOwner.ts`) по нему узнаёт плашку-подпись, которая
 * рисует текст сама, и не отдаёт подпись symbol-блоку.
 */
export const CREATOR_DISPLAY_STYLE_KEY = 'creatorDisplay';

/** Режимы отображения места в «Креативе»: значения `creatorDisplay` и свойства `_display`. */
export const CREATOR_DISPLAY_MODES = ['spot', 'image', 'event', 'link', 'label'] as const;
export type CreatorDisplayMode = (typeof CREATOR_DISPLAY_MODES)[number];
